import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { TabMenu } from 'primereact/tabmenu';
import { fetchVendor, fetchVendors, getEarning, updatefeature, updateVendor } from '../apis/vendors';
import toast, { Toaster } from 'react-hot-toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
// import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';


export default function Vendors() {
    // const [globalFilter, setGlobalFilter] = useState('');
    const [selectedVendor, setSelectedVendor] = useState(null);
    // const [rowClick, setRowClick] = useState(true);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [visibleEarning, setVisibleEarning] = useState(false);
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [vendor, setVendor] = useState();
    const vendorLimit = 15;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [totalEarning, setTotalEarning] = useState(null);
    const [totalOrders, setTotalOrders] = useState(null);
    const [earningVendor, setEarningVendor] = useState(null);
    const [isEarning, setEarning] = useState(false);

    const getVendor = async (e) => {
        try {
            const vendorId = e.data['vendorId'];
            setLoading(true);
            if (e.data != null) {
                const vendor = await fetchVendor(vendorId);
                setVisible(true);
                console.log(vendor);
                setVendor(vendor);
                toast.success('Vendor Fetched');
            }
        } catch (error) {
            setVisible(false);
            console.log(error);
            const errorText = error['response']['statusText'];
            toast.error(`Error Getting Vendor Details - ${errorText}`);
        } finally {
            setLoading(false);
        }
    }

    const onPage = async (event) => {
        // console.log(event);
        setFirst(event.first);
        setPage(event.page);
        try {
            await getVendors(event.page, activeIndex);
        } catch (error) {
            // console.log('139 - error');
            console.log(error);
        }
    };

    const onRowSelect = (event) => {
        console.log('246 - row select');
        console.log(event);
        getVendor(event);
    };

    const onRowUnselect = (event) => {
        setVisible(false);
        console.log(260);
        console.log(event);
    };

    const [activeIndex, setActiveIndex] = useState(0);
    const [vendors, setVendors] = useState([]);

    const tabItems = [
        { label: 'Verified' },
        { label: 'UnVerified' },
        { label: 'Blocked' }
    ];

    const getVendors = async (page, index) => {
        setLoading(true);

        try {

            // const status = index === 0 ? 'true' : 'false';
            const status = index === 0 ? 'verified' : index === 1 ? 'pending' : 'blocked';
            const vendors = await fetchVendors(page, status);
            // console.log(vendors);

            if (vendors.length !== 0) {
                // console.log(vendors[0]['size']);
                setTotalPage(parseInt(vendors[0]['size']));
            } else {
                setTotalPage(0);
            }
            setVendors(vendors);
        } catch (error) {
            console.error("Error fetching Vendors: ", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getVendors(0, activeIndex);
    }, [activeIndex]);

    const modifyVendor = async (action, id) => {
        try {


            console.log(action);
            console.log(id);

            const data = await updateVendor(id, action);

            console.log('184 after update vendor');
            console.log(data);

            if (page > 0 && vendors.length === 1) {
                await getVendors(page - 1, activeIndex);
            } else {
                await getVendors(page, activeIndex);
            }
        } catch (error) {
            toast.error('Error verifying vendor');
        }
    };

    const featureUpdate = async (action, id) => {
        try {
            console.log(action);
            console.log(id);

            const data = await updatefeature(id, action);

            console.log('184 after update vendor');
            console.log(data);

            if (page > 0 && vendors.length === 1) {
                await getVendors(page - 1, activeIndex);
            } else {
                await getVendors(page, activeIndex);
            }
        } catch (error) {
            toast.error(action ? 'Error Featuring Vendor' : 'Error Un-Featuring Vendor');
        }
    };

    const showEarningModal = (riderId) => {
        setEarningVendor(riderId);
        setVisibleEarning(true);
    }

    const getRiderEarning = async () => {
        try {
            if (startDate == null || endDate == null) {
                toast.error('Please select start and end date');
                return;
            }

            if (startDate > endDate) {
                toast.error("Start date must be before end date");
                return;
            }
            setEarning(true);

            console.log(startDate);
            console.log(endDate);

            const data = await getEarning(earningVendor, startDate, endDate);

            // show dialog 

            console.log('227 after getting earning');
            console.log(data);

            if (data) {
                setTotalEarning(data.money);
                setTotalOrders(data.orders);
            }

            // if (page > 0 && riders.length === 1) {
            //     await getRiders(page - 1, activeIndex);
            // } else {
            //     await getRiders(page, activeIndex);
            // }
        } catch (error) {
            toast.error('Error fetching Earning');
        } finally {
            setEarning(false);
        }
    };

    const hideDialogEarning = () => {
        if (!visibleEarning) return;
        setVisibleEarning(false);
        setTotalEarning(null);
        setTotalOrders(null);
        setStartDate(null);
        setEndDate(null);
    }

    const hideDialog = () => {
        if (!visible) return;
        setVisible(false);
        setSelectedVendor(null);;
    }




    return (
        <>
            <Toaster />
            <div className="card">
                {/* <h2 style={{ marginBlock: '1rem' }}>All Vendors</h2> */}
                <TabMenu
                    model={tabItems}
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                    pt={{
                        menu: { className: 'gap-2 mb-2' } // Tailwind: adds space between items
                    }}
                />
                {/* <DataTable value={vendors} lazy paginator rows={vendorLimit} totalRecords={totalPage} first={first} onPage={onPage} loading={loading} emptyMessage={!loading && `No Vendors found`} tableStyle={{ minWidth: '50rem' }} selectionMode={rowClick ? null : 'checkbox'} selection={selectedVendor} onSelectionChange={(e) => { */}
                <DataTable value={vendors} lazy paginator rows={vendorLimit} totalRecords={totalPage} first={first} onPage={onPage} loading={loading} emptyMessage={!loading && `No Vendors found`} tableStyle={{ minWidth: '50rem' }} selection={selectedVendor} onSelectionChange={(e) => {
                    setSelectedVendor(e.value);
                }} onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} scrollable scrollHeight="80vh"
                    paginatorTemplate="PrevPageLink NextPageLink CurrentPageReport"
                    currentPageReportTemplate="Total Vendors: {totalRecords}"
                >
                    <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="phoneNumber" header="Phone Number"></Column>
                    {/* <Column field="email" header="Email"></Column> */}
                    {activeIndex === 0 && (
                        <Column
                            header="Earning"
                            body={(rowData) => (
                                <Button
                                    icon="pi pi-dollar"
                                    label="Show Earning"
                                    tooltip="Show earning of this vendor"
                                    size="small"
                                    severity="success"
                                    onClick={() => showEarningModal(rowData.vendorId)}
                                />
                            )}
                        />
                    )}
                    <Column header="Action" body={(rowData) => (
                        // activeIndex === 0
                        //     ?
                        //     rowData.isFeatured === true ?
                        //         <Button icon="pi pi-ban" label="Un-Feature" tooltip='Unfeature this vendor' size='small' severity='danger' onClick={() => featureUpdate('false', rowData.vendorId)} />
                        //         :
                        //         <Button icon="pi pi-crown" label="Feature" tooltip='Feature this vendor' size='small' severity='success' onClick={() => featureUpdate('true', rowData.vendorId)} />
                        //     :
                        //     <Button icon="pi pi-check" label="Verify" tooltip='Verify this vendor' size='small' severity="success" onClick={() => verifyVendor('true', rowData.vendorId)} />

                        activeIndex === 0
                            ?
                            rowData.isFeatured === true ?
                                <>
                                    <Button icon="pi pi-ban" label="Un-Feature" tooltip='Unfeature this vendor' size='small' severity='danger' className="mr-4" onClick={() => featureUpdate('false', rowData.vendorId)} />
                                    <Button icon="pi pi-ban" label="Block" tooltip='Block this vendor' size='small' severity='danger' onClick={() => modifyVendor('blocked', rowData.vendorId)} />
                                </>
                                :
                                <>
                                    <Button icon="pi pi-crown" label="Feature" tooltip='Feature this vendor' size='small' severity='success' className="mr-4" onClick={() => featureUpdate('true', rowData.vendorId)} />
                                    <Button icon="pi pi-ban" label="Block" tooltip='Block this vendor' size='small' severity='danger' onClick={() => modifyVendor('blocked', rowData.vendorId)} />
                                </>
                            :
                            activeIndex === 1 ?
                                <Button icon="pi pi-check" label="Verify" tooltip='Verify this vendor' size='small' severity="success" onClick={() => modifyVendor('verified', rowData.vendorId)} />
                                :
                                <Button icon="pi pi-check" label="Un-Block" tooltip='Unblock this vendor' size='small' severity="success" onClick={() => modifyVendor('verified', rowData.vendorId)} />
                    )} />
                </DataTable>
            </div >
            <Dialog
                header="Vendor Info"
                visible={visible}
                onHide={hideDialog}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                {
                    vendor ?
                        <div className="p-d-flex p-ai-center">
                            <div
                                className="p-mr-3"
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'green',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '1.5rem',
                                }}
                            >
                                {vendor.shopName.charAt(0)}
                            </div>
                            <div>
                                <p><strong>Name:</strong> {vendor.name}</p>
                                <p><strong>Email:</strong> {vendor.email}</p>
                                <p><strong>Phone Number:</strong> {vendor.phoneNumber}</p>
                                <p><strong>Aadhar Number:</strong> {vendor.aadharNumber}</p>
                                <p><strong>PAN Number:</strong> {vendor.panNumber}</p>
                                <p><strong>Shop Address:</strong> {vendor.shopAddress}</p>
                                <p><strong>Shop Name:</strong> {vendor.shopName}</p>
                                <p><strong>Status:</strong> {vendor.status}</p>
                                <p><strong>Featured:</strong> {vendor.isFeatured ? "Yes" : "No"}</p>
                            </div>
                        </div>
                        : <></>
                }
            </Dialog>

            <Dialog
                header="Vendor Earning"
                visible={visibleEarning}
                onHide={hideDialogEarning}
                style={{ width: '50vw' }}
                className="p-fluid"
            >
                <div className="p-field p-grid">
                    <label htmlFor="startDate" className="p-col-12 p-md-2">Start Date</label>
                    <div className="p-col-12 p-md-10 my-2">
                        <Calendar id="startDate" value={startDate} onChange={(e) => setStartDate(e.value)} showIcon />
                    </div>
                </div>

                <div className="p-field p-grid">
                    <label htmlFor="endDate" className="p-col-12 p-md-2">End Date</label>
                    <div className="p-col-12 p-md-10 my-2">
                        <Calendar id="endDate" value={endDate} onChange={(e) => setEndDate(e.value)} showIcon />
                    </div>
                </div>

                <div className="p-field p-grid my-3">
                    <div className="p-col-12 p-text-center">
                        <Button label="Calculate Earning" icon={`pi ${isEarning ? 'pi-spinner pi-spin' : 'pi-check'}`}
                            onClick={getRiderEarning} />
                    </div>
                </div>

                {totalEarning !== null && totalOrders !== null && (
                    <div className="p-mt-4">
                        <div className="p-field p-grid">
                            <label className="p-col-12 p-md-2">Total Earning</label>
                            <div className="p-col-12 p-md-10">
                                <InputText value={`₹${totalEarning}`} readOnly />
                            </div>
                        </div>

                        <div className="p-field p-grid">
                            <label className="p-col-12 p-md-2">Total Orders</label>
                            <div className="p-col-12 p-md-10">
                                <InputText value={totalOrders} readOnly />
                            </div>
                        </div>
                    </div>
                )}
            </Dialog>
        </>
    );
}

